module.exports = __webpack_public_path__ + "img/renegades1.441fa3a.jpg";